import { useState } from "react";
import { t } from "@/i18n-js/instance";
import {
  useTailwindLgScreenMediaQuery,
  useTailwindMdScreenMediaQuery,
} from "@circle-react/hooks/useMediaQuery";
import { Typography } from "@circle-react-uikit/Typography";

interface PaywallDescriptionProp {
  description?: string;
}

const maximumLengthVariants = {
  desktop: 160,
  tablet: 250,
  mobile: 120,
};

const getVariant = (isTablet: boolean, isDesktop: boolean) => {
  if (isDesktop) {
    return "desktop";
  }

  if (isTablet) {
    return "tablet";
  }

  return "mobile";
};

export const PaywallDescription = ({ description }: PaywallDescriptionProp) => {
  const [shouldShowMoreText, setShouldShowMore] = useState(false);
  const onClick = () => {
    setShouldShowMore(!shouldShowMoreText);
  };

  const isTablet = useTailwindMdScreenMediaQuery();
  const isDesktop = useTailwindLgScreenMediaQuery();
  const variant = getVariant(isTablet, isDesktop);

  if (!description) {
    return null;
  }

  if (description.length <= maximumLengthVariants[variant]) {
    return (
      <Typography.BodySm color="text-default">
        <span className="whitespace-pre-wrap">{description}</span>
      </Typography.BodySm>
    );
  }

  return (
    <Typography.BodySm color="text-default">
      {shouldShowMoreText ? (
        <span className="flex flex-col gap-y-1 whitespace-pre-wrap">
          {description}
          <button
            type="button"
            className="text-left underline"
            onClick={onClick}
          >
            {t("show_less")}
          </button>
        </span>
      ) : (
        <span className="whitespace-pre-wrap">
          {`${description.substring(0, maximumLengthVariants[variant])}... `}
          <button type="button" className="underline" onClick={onClick}>
            {t("show_more")}
          </button>
        </span>
      )}
    </Typography.BodySm>
  );
};
